import { Routes, Route } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AttendancePage } from './pages/AttendancePage';
import { MarksPage } from './pages/MarksPage';
import { CoScholasticPage } from './pages/CoScholasticPage';
import { OpticalSyncHub } from './pages/OpticalSyncHub';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { UdiseIngestion } from './pages/admin/UdiseIngestion';
import { BlockForge } from './pages/admin/BlockForge';
import { ReportGenerator } from './pages/admin/ReportGenerator';
import { ManageTeachers } from './pages/admin/ManageTeachers';
import { AdminSettings } from './pages/admin/AdminSettings';
import DPDPConsentPage from './pages/admin/DPDPConsentPage';
import { AdminRollover } from './pages/admin/AdminRollover';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PrivacyGate } from './components/PrivacyGate';
import { GlobalShell } from './components/GlobalShell';
import { HistoryPage } from './pages/HistoryPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<LoginPage />} />
      
      {/* Teacher Routes */}
      <Route element={<ProtectedRoute allowedRoles={['teacher', 'admin']}><GlobalShell /></ProtectedRoute>}>
        <Route path="/teacher/dashboard" element={<DashboardPage />} />
        <Route path="/teacher/attendance" element={<AttendancePage />} />
        <Route path="/teacher/register/:classId/:subjectId" element={<MarksPage />} />
        <Route path="/teacher/coscholastic/:classId" element={<CoScholasticPage />} />
        <Route path="/teacher/history" element={<HistoryPage />} />
        <Route path="/sync-hub" element={<OpticalSyncHub />} />
        
        {/* Backwards compatibility */}
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/marks" element={<MarksPage />} />
      </Route>

      {/* Admin Routes */}
      <Route element={<ProtectedRoute allowedRoles={['admin']}><GlobalShell /></ProtectedRoute>}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/consent" element={<DPDPConsentPage />} />
        
        {/* DPDP Guarded Routes (PII Data Entry) */}
        <Route path="/admin/udise" element={<PrivacyGate><UdiseIngestion /></PrivacyGate>} />
        <Route path="/admin/users" element={<PrivacyGate><ManageTeachers /></PrivacyGate>} />
        
        <Route path="/admin/schema" element={<BlockForge />} />
        <Route path="/admin/reports" element={<ReportGenerator />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/rollover" element={<AdminRollover />} />
        <Route path="/admin/history" element={<PrivacyGate><HistoryPage /></PrivacyGate>} />
      </Route>
    </Routes>
  );
}
